// Ensure zoom is globally available for inline onmousemove
window.zoom = function(e) {
  const zoomer = e.currentTarget;
  let offsetX, offsetY;

  if (e.offsetX !== undefined && e.offsetY !== undefined) {
    offsetX = e.offsetX;
    offsetY = e.offsetY;
  } else if (e.touches && e.touches.length > 0) {
    const rect = zoomer.getBoundingClientRect();
    offsetX = e.touches[0].clientX - rect.left;
    offsetY = e.touches[0].clientY - rect.top;
  } else {
    return;
  }

  const x = (offsetX / zoomer.offsetWidth) * 100;
  const y = (offsetY / zoomer.offsetHeight) * 100;

  zoomer.style.backgroundPosition = `${x}% ${y}%`;
};


$(document).ready(function () {
  if (window.innerWidth <= 768) {
    $('.nutrients-sec .herbs-accordion').each(function () {
      var $accordion = $(this);
      var imgSrc = $accordion.find('.accordion-title').data('img');

      if (imgSrc) {
        // Check if image already exists to avoid duplication
        if ($accordion.find('.accordion-content img.accordion-img').length === 0) {
          $('<img>', {
            class: 'accordion-img',
            src: imgSrc,
            alt: 'Accordion Image'
          }).prependTo($accordion.find('.accordion-content'));
        }
      }
    });
  }
});


gsap.registerPlugin(ScrollTrigger);

let tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".multivitamin-split-scroll",
    start: "top top",
    end: "bottom top",
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    // markers: true,
    // toggleActions: "play none none reverse"
     scrub: true,  
  }
});

// Slide up and hide img-1
tl.to(".main-sliding-img.img-1", { 
  y: "-100%", 
  autoAlpha: 0,  
  ease: "power3.inOut",
  duration: 1
})
// Slide in img-2
.fromTo(".main-sliding-img.img-2", 
  { y: "100%", autoAlpha: 0 }, 
  { y: "0%", autoAlpha: 1, ease: "power3.inOut", duration: 1 }, "<"
)
// Background change
.to(".multivitamin-split-scroll", {
  backgroundColor: "#f0f0f0",
  ease: "power3.inOut",
  duration: 1
}, "<")
// Slide out main-txt-slide left side
.to(".left-side .main-txt-slide", {
  x: "-100%",        
  autoAlpha: 0,      
  ease: "power3.inOut",
  duration: 1
}, "<")
// Slide out main-txt-slide right side
.to(".right-side .main-txt-slide", {
  x: "100%",         
  autoAlpha: 0,
  ease: "power3.inOut",
  duration: 1
}, "<")
// Slide in main-txt-next-slide left side (AFTER previous slide out completes)
.fromTo(".left-side .main-txt-next-slide",
  { x: "-100%", autoAlpha: 0 },   // Start offscreen left
  { x: "0%", autoAlpha: 1, ease: "power3.inOut", duration: 1 }
)
// Slide in main-txt-next-slide right side (simultaneous)
.fromTo(".right-side .main-txt-next-slide",
  { x: "100%", autoAlpha: 0 },    // Start offscreen right
  { x: "0%", autoAlpha: 1, ease: "power3.inOut", duration: 1 }, "<"
);



var modal = document.querySelector(".cos-modal");
var trigger = document.querySelector(".plain_btn");
var closeButton = document.querySelector(".close-button");
var body = document.querySelector(".template-product-multivitamin");

function toggleModal() {
    modal.classList.toggle("show-modal");
    body.classList.toggle("active-modal");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

trigger.addEventListener("click", toggleModal);
closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);


gsap.registerPlugin(ScrollTrigger);

let pillTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".pill-boxs",
    start: "top top+=150",
    end: "+=100%",
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    scrub: true
  }
});

// Step 1 — Slide out img-1 (slides up)
pillTl.fromTo(".pill-boxs .main-sliding-img-mobile.img-1",
  { y: "0%", autoAlpha: 1 },
  { 
    y: "-100%", 
    autoAlpha: 0, 
    ease: "power3.inOut", 
    duration: 1,
    onUpdate: function() {
      if (this.progress() > 0.99) {
        document.querySelector(".pill-boxs .main-sliding-img-mobile.img-1")?.classList.add("hide-m");
      } else {
        document.querySelector(".pill-boxs .main-sliding-img-mobile.img-1")?.classList.remove("hide-m");
      }
    }
  }
)

// Step 2 — Slide in img-2
.fromTo(".pill-boxs .main-sliding-img-mobile.img-2",
  { y: "100%", autoAlpha: 0 },
  { 
    y: "0%", 
    autoAlpha: 1, 
    ease: "power3.inOut", 
    duration: 1,
    onUpdate: function() {
      if (this.progress() > 0.01) {
        document.querySelector(".pill-boxs .main-sliding-img-mobile.img-2")?.classList.remove("hide-m");
      } else {
        document.querySelector(".pill-boxs .main-sliding-img-mobile.img-2")?.classList.add("hide-m");
      }
    }
  }, "<"
)

// Step 3 — Background color change
.to(".pill-boxs", {
  backgroundColor: "#f0f0f0",
  ease: "power3.inOut",
  duration: 1
}, "<")

// Step 4 — Fade out .pill-text-box (no sliding)
.to(".pill-boxs .pill-text-box", {
  autoAlpha: 0,
  ease: "power3.inOut",
  duration: 1,
  stagger: 0.2,
  onUpdate: function() {
    document.querySelectorAll(".pill-boxs .pill-text-box").forEach(el => {
      if (this.progress() > 0.99) {
        el.classList.add("hide-me");
      } else {
        el.classList.remove("hide-me");
      }
    });
  }
}, "<")

// Step 5 — Fade in .next-text-slide (no sliding)
.fromTo(".pill-boxs .next-text-slide",
  { autoAlpha: 0 },
  { 
    autoAlpha: 1, 
    ease: "power3.inOut", 
    duration: 1,
    stagger: 0.2,
    onUpdate: function() {
      document.querySelectorAll(".pill-boxs .next-text-slide").forEach(el => {
        if (this.progress() > 0.01) {
          el.classList.remove("hide-me");
        } else {
          el.classList.add("hide-me");
        }
      });
    }
  }
);



// // Gallery zoom for desktop
//     function zoom(e){
//       var zoomer = e.currentTarget;
//       e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
//       e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
//       x = offsetX/zoomer.offsetWidth*100
//       y = offsetY/zoomer.offsetHeight*100
//       zoomer.style.backgroundPosition = x + '% ' + y + '%';
//     }


